

// // // src/pages/BookHomeServices.jsx
// // import React, { useEffect, useMemo, useState } from "react";
// // import "./book-services.css";
// // import { subscribeCategories, subscribeHomeServices } from "../lib/servicesApi";
// // import { useBookings } from "../hooks/useBookings";
// // // import { useAuth } from ... // if you have a hook to get current user

// // const BookHomeServices = () => {
// //   const [activeCat, setActiveCat] = useState("all");
// //   const [cats, setCats] = useState([]);
// //   const [catError, setCatError] = useState(null);

// //   const [list, setList] = useState([]);
// //   const [svcError, setSvcError] = useState(null);
// //   const [selected, setSelected] = useState(null);

// //   // If you have auth, get current userId
// //   const userId = null; // replace with your auth UID (e.g., user?.uid)

// //   const { create, loading: bookingLoading, error: bookingError } = useBookings();

// //   useEffect(() => {
// //     const unsubCats = subscribeCategories(setCats, setCatError);
// //     return () => unsubCats();
// //   }, []);

// //   useEffect(() => {
// //     const unsubSvc = subscribeHomeServices(
// //       setList,
// //       setSvcError,
// //       { category: activeCat === "all" ? undefined : activeCat }
// //     );
// //     return () => unsubSvc();
// //   }, [activeCat]);

// //   const filters = useMemo(() => {
// //     const chips = [{ key: "all", label: "All" }];
// //     const activeCats = cats.filter((c) => c.active);
// //     for (const c of activeCats) chips.push({ key: c.key, label: c.label || c.key });
// //     return chips;
// //   }, [cats]);

// //   const services = useMemo(() => {
// //     const activeOnly = list.filter((s) => s.active);
// //     if (activeCat === "all") return activeOnly;
// //     return activeOnly.filter((s) => s.category === activeCat);
// //   }, [list, activeCat]);

// //   const openBooking = (svc) => setSelected(svc);
// //   const closeBooking = () => setSelected(null);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!selected) return;
// //     const fd = new FormData(e.currentTarget);
// //     const data = Object.fromEntries(fd.entries());

// //     try {
// //       await create({
// //         serviceId: selected.id,
// //         serviceTitle: selected.title,
// //         category: selected.category,
// //         icon: selected.icon,
// //         price: selected.price,
// //         userId, // null or your uid
// //         date: data.date,
// //         time: data.time,
// //         address: data.address,
// //         notes: data.notes,
// //       });
// //       closeBooking();
// //       alert(`Booking submitted for "${selected.title}". We’ll reach out soon!`);
// //     } catch (err) {
// //       // bookingError already captured in hook
// //       console.error("Booking error:", err);
// //     }
// //   };

// //   return (
// //     <section id="book-services" className="py-5 bg-light">
// //       <div className="container">
// //         <header className="mb-4 text-center">
// //           <h2 className="fw-bold">Book Home &amp; Kitchen Services</h2>
// //           <p className="text-muted mb-2">Reliable professionals for cleaning, repairs, cooking, and essentials.</p>
// //         </header>

// //         {/* Filters */}
// //         <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
// //           {filters.map((cat) => (
// //             <button
// //               key={cat.key}
// //               type="button"
// //               className={`btn btn-sm ${activeCat === cat.key ? "btn-primary-navbar-reg" : "btn-outline-teal"}`}
// //               onClick={() => setActiveCat(cat.key)}
// //               aria-pressed={activeCat === cat.key}
// //               aria-label={`Filter ${cat.label}`}
// //             >
// //               {cat.label}
// //             </button>
// //           ))}
// //         </div>

// //         {catError && <div className="alert alert-danger">Failed to load categories: {catError.message}</div>}
// //         {svcError && <div className="alert alert-danger">Failed to load services: {svcError.message}</div>}
// //         {bookingError && <div className="alert alert-danger">Booking failed: {bookingError.message}</div>}

// //         {/* Cards */}
// //         <div className="row g-3">
// //           {services.map((svc) => (
// //             <div key={svc.id} className="col-12 col-sm-6 col-lg-4">
// //               <article className="card h-100 shadow-sm">
// //                 <div className="card-body d-flex flex-column">
// //                   <div className="d-flex align-items-center mb-2">
// //                     <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
// //                       <i className={`bi ${svc.icon} text-primary-label fs-5`} aria-hidden="true"></i>
// //                     </span>
// //                     <h5 className="card-title mb-0">{svc.title}</h5>
// //                   </div>
// //                   <p className="text-muted mb-2 flex-grow-1">{svc.desc}</p>
// //                   <div className="d-flex align-items-center justify-content-between">
// //                     <span className="text-secondary">Starting at ₹{svc.price}</span>
// //                     <button
// //                       type="button"
// //                       className="btn btn-outline-teal btn-sm"
// //                       onClick={() => openBooking(svc)}
// //                       aria-label={`Book ${svc.title}`}
// //                     >
// //                       Book Service
// //                     </button>
// //                   </div>
// //                 </div>
// //               </article>
// //             </div>
// //           ))}
// //           {services.length === 0 && !svcError && (
// //             <div className="col-12">
// //               <div className="alert alert-info">No services available for this category yet.</div>
// //             </div>
// //           )}
// //         </div>

// //         {/* Booking Modal */}
// //         <div className={`modal fade ${selected ? "show d-block" : ""}`} tabIndex={-1}
// //              role="dialog" aria-modal={selected ? "true" : "false"} aria-hidden={selected ? "false" : "true"}>
// //           <div className="modal-dialog modal-dialog-centered">
// //             <div className="modal-content">
// //               <div className="modal-header">
// //                 <h5 className="modal-title">{selected ? `Book: ${selected.title}` : "Book Service"}</h5>
// //                 <button type="button" className="btn-close" aria-label="Close" onClick={closeBooking} />
// //               </div>
// //               <div className="modal-body">
// //                 {selected && (
// //                   <form onSubmit={handleSubmit}>
// //                     <div className="mb-3 d-flex align-items-center">
// //                       <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
// //                         <i className={`bi ${selected.icon} text-primary-label fs-5`} aria-hidden="true"></i>
// //                       </span>
// //                       <div>
// //                         <div className="fw-semibold">{selected.title}</div>
// //                         <small className="text-muted">Starting at ₹{selected.price}</small>
// //                       </div>
// //                     </div>

// //                     <div className="row g-3">
// //                       <div className="col-12 col-md-6">
// //                         <label className="form-label" htmlFor="date">Date</label>
// //                         <input type="date" id="date" name="date" className="form-control" required />
// //                       </div>
// //                       <div className="col-12 col-md-6">
// //                         <label className="form-label" htmlFor="time">Time</label>
// //                         <input type="time" id="time" name="time" className="form-control" required />
// //                       </div>
// //                       <div className="col-12">
// //                         <label className="form-label" htmlFor="address">Address</label>
// //                         <input id="address" name="address" className="form-control" placeholder="Flat / Tower / Street" required />
// //                       </div>
// //                       <div className="col-12">
// //                         <label className="form-label" htmlFor="notes">Notes (optional)</label>
// //                         <textarea id="notes" name="notes" className="form-control" rows={3}
// //                                   placeholder="Any specifics? e.g., brand/model, problem details"></textarea>
// //                       </div>
// //                     </div>

// //                     <div className="mt-3 d-flex justify-content-end gap-2">
// //                       <button type="button" className="btn btn-outline-secondary" onClick={closeBooking}>
// //                         Cancel
// //                       </button>
// //                       <button type="submit" className="btn btn-primary" disabled={bookingLoading}>
// //                         {bookingLoading ? "Submitting..." : "Confirm Booking"}
// //                       </button>
// //                     </div>
// //                   </form>
// //                 )}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //         {selected && <div className="modal-backdrop fade show" onClick={closeBooking} />}
// //       </div>
// //     </section>
// //   );
// // };

// // export default BookHomeServices;

// // src/pages/BookHomeServices.jsx
// import React, { useMemo, useState } from "react";
// import "./book-services.css";

// const CATEGORIES = [
//   { key: "all",      label: "All" },
//   { key: "cleaning", label: "Cleaning" },
//   { key: "repairs",  label: "Repairs" },
//   { key: "kitchen",  label: "Kitchen" },
//   { key: "essential",label: "Essentials" },
// ];

// // Catalog: extend freely
// const CATALOG = [
//   // Cleaning
//   {
//     id: "maid-basic",
//     title: "Maid Services (Daily/On-call)",
//     desc: "Sweeping, mopping, dishes, dusting—flexible plans.",
//     icon: "bi-person-lines-fill",
//     category: "cleaning",
//     price: 299,
//   },
//   {
//     id: "bathroom-clean",
//     title: "Bathroom Deep Cleaning",
//     desc: "Scale removal, grout, glass & fixtures cleaned.",
//     icon: "bi-droplet",
//     category: "cleaning",
//     price: 899,
//   },
//   {
//     id: "kitchen-deep",
//     title: "Kitchen Deep Cleaning",
//     desc: "Grease, chimney filters, shelves, tiles—thorough clean.",
//     icon: "bi-egg-fried",
//     category: "cleaning",
//     price: 1199,
//   },

//   // Repairs
//   {
//     id: "plumbing",
//     title: "Plumbing",
//     desc: "Leaks, taps, flush, drainage, RO inlet/outlet.",
//     icon: "bi-water",
//     category: "repairs",
//     price: 399,
//   },
//   {
//     id: "electrical",
//     title: "Electrical",
//     desc: "Switches, wiring, fan/AC issues, appliance setup.",
//     icon: "bi-lightning-charge",
//     category: "repairs",
//     price: 399,
//   },
//   {
//     id: "appliance-repair",
//     title: "Appliance Repair",
//     desc: "Washing machine, fridge, microwave, RO, chimney.",
//     icon: "bi-tools",
//     category: "repairs",
//     price: 499,
//   },

//   // Kitchen
//   {
//     id: "cook-on-demand",
//     title: "Cook on Demand",
//     desc: "Home-style meals; hourly or per-meal bookings.",
//     icon: "bi-knife",
//     category: "kitchen",
//     price: 349,
//   },
//   {
//     id: "grocery-run",
//     title: "Grocery Quick Drop",
//     desc: "Pickup & drop essentials from nearby stores.",
//     icon: "bi-bag-check",
//     category: "kitchen",
//     price: 149,
//   },

//   // Essentials / Transport
//   {
//     id: "quick-drop",
//     title: "Quick Drop (Transport)",
//     desc: "Local pick-up & drop for parcels or errands.",
//     icon: "bi-truck",
//     category: "essential",
//     price: 149,
//   },
//   {
//     id: "laundry",
//     title: "Laundry",
//     desc: "Pickup, wash/iron, and return at your doorstep.",
//     icon: "bi-bucket",
//     category: "essential",
//     price: 249,
//   },
// ];

// const BookHomeServices = () => {
//   const [activeCat, setActiveCat] = useState("all");
//   const [selected, setSelected] = useState(null); // service object

//   const services = useMemo(
//     () => (activeCat === "all" ? CATALOG : CATALOG.filter(s => s.category === activeCat)),
//     [activeCat]
//   );

//   const openBooking = (svc) => setSelected(svc);
//   const closeBooking = () => setSelected(null);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const fd = new FormData(e.currentTarget);
//     const data = Object.fromEntries(fd.entries());
//     // TODO: call your API to create a booking (serviceId, date, time, address, notes)
//     console.log("Booking request:", { serviceId: selected?.id, ...data });
//     closeBooking();
//     alert(`Booking submitted for "${selected?.title}". We’ll reach out soon!`);
//   };

//   return (
//     <section id="book-services" className="py-5 bg-light">
//       <div className="container">
//         <header className="mb-4 text-center">
//           <h2 className="fw-bold">Book Home &amp; Kitchen Services</h2>
//           <p className="text-muted mb-2">
//             Reliable professionals for cleaning, repairs, cooking, and essentials.
//           </p>
//         </header>

//         {/* Filters */}
//         <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
//           {CATEGORIES.map(cat => (
//             <button
//               key={cat.key}
//               type="button"
//               className={`btn btn-sm ${activeCat === cat.key ? "btn-outline-teal" : "btn-outline-teal"}`}
//               onClick={() => setActiveCat(cat.key)}
//               aria-pressed={activeCat === cat.key}
//               aria-label={`Filter ${cat.label}`}
//             >
//               {cat.label}
//             </button>
//           ))}
//         </div>

//         {/* Cards */}
//         <div className="row g-3">
//           {services.map(svc => (
//             <div key={svc.id} className="col-12 col-sm-6 col-lg-4">
//               <article className="card h-100 shadow-sm">
//                 <div className="card-body d-flex flex-column">
//                   {/* Icon + title */}
//                   <div className="d-flex align-items-center mb-2">
//                     <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
//                       <i className={`bi ${svc.icon} text-primary-label fs-5`} aria-hidden="true"></i>
//                     </span>
//                     <h5 className="card-title mb-0">{svc.title}</h5>
//                   </div>

//                   {/* Desc */}
//                   <p className="text-muted mb-2 flex-grow-1">{svc.desc}</p>

//                   {/* Price + CTA */}
//                   <div className="d-flex align-items-center justify-content-between">
//                     <span className="text-secondary">Starting at ₹{svc.price}</span>
//                     <button
//                       type="button"
//                       className="btn btn-outline-teal btn-sm"
//                       onClick={() => openBooking(svc)}
//                       aria-label={`Book ${svc.title}`}
//                     >
//                       Book Service
//                     </button>
//                   </div>
//                 </div>
//               </article>
//             </div>
//           ))}
//         </div>

//         {/* Booking Modal (controlled) */}
//         <div
//           className={`modal fade ${selected ? "show d-block" : ""}`}
//           tabIndex={-1}
//           role="dialog"
//           aria-modal={selected ? "true" : "false"}
//           aria-hidden={selected ? "false" : "true"}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   {selected ? `Book: ${selected.title}` : "Book Service"}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeBooking}
//                 />
//               </div>
//               <div className="modal-body">
//                 {selected && (
//                   <form onSubmit={handleSubmit}>
//                     <div className="mb-3 d-flex align-items-center">
//                       <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
//                         <i className={`bi ${selected.icon} text-primary-label fs-5`} aria-hidden="true"></i>
//                       </span>
//                       <div>
//                         <div className="fw-semibold">{selected.title}</div>
//                         <small className="text-muted">Starting at ₹{selected.price}</small>
//                       </div>
//                     </div>

//                     <div className="row g-3">
//                       <div className="col-12 col-md-6">
//                         <label className="form-label" htmlFor="date">Date</label>
//                         <input type="date" id="date" name="date" className="form-control" required />
//                       </div>
//                       <div className="col-12 col-md-6">
//                         <label className="form-label" htmlFor="time">Time</label>
//                         <input type="time" id="time" name="time" className="form-control" required />
//                       </div>
//                       <div className="col-12">
//                         <label className="form-label" htmlFor="address">Address</label>
//                         <input id="address" name="address" className="form-control" placeholder="Flat / Tower / Street" required />
//                       </div>
//                       <div className="col-12">
//                         <label className="form-label" htmlFor="notes">Notes (optional)</label>
//                         <textarea id="notes" name="notes" className="form-control" rows={3} placeholder="Any specifics? e.g., brand/model, problem details"></textarea>
//                       </div>
//                     </div>

//                     <div className="mt-3 d-flex justify-content-end gap-2">
//                       <button type="button" className="btn btn-outline-secondary" onClick={closeBooking}>
//                         Cancel
//                       </button>
//                       <button type="submit" className="btn btn-primary">
//                         Confirm Booking
//                       </button>
//                     </div>
//                   </form>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Backdrop for the controlled modal */}
//         {selected && <div className="modal-backdrop fade show" onClick={closeBooking} />}
//       </div>
//     </section>
//   );
// };

// export default BookHomeServices;


// src/pages/BookHomeServices.jsx
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom"; // <-- add (works if you use React Router)
import "./book-services.css";

const CATEGORIES = [
  { key: "all",      label: "All" },
  { key: "cleaning", label: "Cleaning" },
  { key: "repairs",  label: "Repairs" },
  { key: "kitchen",  label: "Kitchen" },
  { key: "essential",label: "Essentials" },
];

// Static catalog (you can keep this or replace with Firestore later)
const CATALOG = [
  // Cleaning
  { id: "maid-basic",     title: "Maid Services (Daily/On-call)", desc: "Sweeping, mopping, dishes, dusting—flexible plans.", icon: "bi-person-lines-fill", category: "cleaning",  price: 99 },
  { id: "bathroom-clean", title: "Bathroom Deep Cleaning",        desc: "Scale removal, grout, glass & fixtures cleaned.",     icon: "bi-droplet",           category: "cleaning",  price: 199 },
  { id: "kitchen-deep",   title: "Kitchen Deep Cleaning",         desc: "Grease, chimney filters, shelves, tiles—thorough clean.", icon: "bi-egg-fried",   category: "cleaning",  price: 599 },
    { id: "car-cleaing",   title: "Car Cleaning ",         desc: "Daily clean, interior clean, water and foam cleaning.", icon: "bi-car-front-fill",   category: "cleaning",  price: 399 },


  // Repairs
  { id: "plumbing",        title: "Plumbing",         desc: "Leaks, taps, flush, drainage, RO inlet/outlet.",         icon: "bi-water",              category: "repairs",   price: 399 },
  { id: "electrical",      title: "Electrical",       desc: "Switches, wiring, fan/AC issues, appliance setup.",      icon: "bi-lightning-charge",   category: "repairs",   price: 399 },
  { id: "appliance-repair",title: "Appliance Repair", desc: "Washing machine, fridge, microwave, RO, chimney.",       icon: "bi-tools",              category: "repairs",   price: 499 },

  // Kitchen
  { id: "cook-on-demand", title: "Cook on Demand",    desc: "Home-style meals; hourly or per-meal bookings.",         icon: "bi-knife",              category: "kitchen",   price: 249 },
  { id: "grocery-run",    title: "Grocery Quick Drop",desc: "Pickup & drop essentials from nearby stores.",           icon: "bi-bag-check",          category: "kitchen",   price: 149 },

  // Essentials / Transport
  { id: "quick-drop",     title: "Quick Drop (Transport)", desc: "Local pick-up & drop for parcels or errands.",      icon: "bi-truck",              category: "essential", price: 149 },
  { id: "laundry",        title: "Laundry",                desc: "Pickup, wash/iron, and return at your doorstep.",  icon: "bi-bucket",             category: "essential", price: 99 },
  
];

const BookHomeServices = () => {
  const navigate = useNavigate(); // <-- if router exists
  const [activeCat, setActiveCat] = useState("all");
  const [selected, setSelected] = useState(null); // service object

  const services = useMemo(
    () => (activeCat === "all" ? CATALOG : CATALOG.filter((s) => s.category === activeCat)),
    [activeCat]
  );

  const openBooking = (svc) => setSelected(svc);
  const closeBooking = () => setSelected(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const data = Object.fromEntries(fd.entries());
    // TODO: call your API to create a booking (serviceId, date, time, address, notes)
    console.log("Booking request:", { serviceId: selected?.id, ...data });
    closeBooking();
    alert(`Booking submitted for "${selected?.title}". We’ll reach out soon!`);
  };

  // Back action with graceful fallback
  const goBack = () => {
    try {
      if (navigate) {
        navigate(-1);
        return;
      }
    } catch {
      // ignore
    }
    // Fallback if navigate isn't available or throws
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // If no history, fallback to home (or any default route)
      window.location.href = "/";
    }
  };

  return (
    <section id="book-services" className="py-5 bg-light">
      <div className="container">

        {/* Sticky mini-header with Back button */}
        <div
          className="d-flex align-items-center justify-content-between mb-3"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            background: "var(--bs-light, #f8f9fa)",
            padding: "8px 0",
          }}
        >
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={goBack}
            aria-label="Go back"
          >
            <i className="bi bi-arrow-left me-1" aria-hidden="true"></i>
            Back
          </button>

          {/* Optional: quick jump to active filter */}
          <span className="text-muted small">
            Viewing: <strong>{CATEGORIES.find((c) => c.key === activeCat)?.label || "All"}</strong>
          </span>
        </div>

        <header className="mb-4 text-center">
          <h2 className="fw-bold">Book Home &amp; Kitchen Services</h2>
          <p className="text-muted mb-2">
            Reliable professionals for cleaning, repairs, cooking, and essentials.
          </p>
        </header>

        {/* Filters */}
        <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
          {CATEGORIES.map((cat) => (
            <button
              key={cat.key}
              type="button"
              className={`btn btn-sm ${activeCat === cat.key ? "btn-primary-navbar-reg" : "btn-outline-teal"}`}
              onClick={() => setActiveCat(cat.key)}
              aria-pressed={activeCat === cat.key}
              aria-label={`Filter ${cat.label}`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Cards */}
        <div className="row g-3">
          {services.map((svc) => (
            <div key={svc.id} className="col-12 col-sm-6 col-lg-4">
              <article className="card h-100 shadow-sm">
                <div className="card-body d-flex flex-column">
                  {/* Icon + title */}
                  <div className="d-flex align-items-center mb-2">
                    <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
                      <i className={`bi ${svc.icon} text-primary-label fs-5`} aria-hidden="true"></i>
                    </span>
                    <h5 className="card-title mb-0">{svc.title}</h5>
                  </div>

                  {/* Desc */}
                  <p className="text-muted mb-2 flex-grow-1">{svc.desc}</p>

                  {/* Price + CTA */}
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="text-secondary">Starting at ₹{svc.price}</span>
                    <button
                      type="button"
                      className="btn btn-outline-teal btn-sm"
                      onClick={() => openBooking(svc)}
                      aria-label={`Book ${svc.title}`}
                    >
                      Book Service
                    </button>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>

        {/* Booking Modal (controlled) */}
        <div
          className={`modal fade ${selected ? "show d-block" : ""}`}
          tabIndex={-1}
          role="dialog"
          aria-modal={selected ? "true" : "false"}
          aria-hidden={selected ? "false" : "true"}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selected ? `Book: ${selected.title}` : "Book Service"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeBooking}
                />
              </div>
              <div className="modal-body">
                {selected && (
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3 d-flex align-items-center">
                      <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
                        <i className={`bi ${selected.icon} text-primary-label fs-5`} aria-hidden="true"></i>
                      </span>
                      <div>
                        <div className="fw-semibold">{selected.title}</div>
                        <small className="text-muted">Starting at ₹{selected.price}</small>
                      </div>
                    </div>

                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label" htmlFor="date">Date</label>
                        <input type="date" id="date" name="date" className="form-control" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label" htmlFor="time">Time</label>
                        <input type="time" id="time" name="time" className="form-control" required />
                      </div>
                      <div className="col-12">
                        <label className="form-label" htmlFor="address">Address</label>
                        <input id="address" name="address" className="form-control" placeholder="Flat / Tower / Street" required />
                      </div>
                      <div className="col-12">
                        <label className="form-label" htmlFor="notes">Notes (optional)</label>
                        <textarea id="notes" name="notes" className="form-control" rows={3} placeholder="Any specifics? e.g., brand/model, problem details"></textarea>
                      </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-end gap-2">
                      <button type="button" className="btn btn-outline-secondary" onClick={closeBooking}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Confirm Booking
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Backdrop for the controlled modal */}
        {selected && <div className="modal-backdrop fade show" onClick={closeBooking} />}
      </div>
    </section>
  );
};

export default BookHomeServices;
